import React from 'react';

import i18n from 'i18n-react';
import PropTypes from 'prop-types';

import { LoginForm, LanguageSelect, StoreButtons } from 'C4';

import Logo from 'assets/images/logo/logo_beta.png';

import apple from 'assets/images/app_store.png';
import google from 'assets/images/google_play.png';

const MobileButtons = () => (
  <div className='button__container'>
    <div className='buttons small'>
      <a
        href='https://apps.apple.com/app/trac-by-rail-europe/id1513169091'
        target='_blank'
      >
        <img src={apple} className='apple' alt='App store' />
      </a>
      <a
        href='https://play.google.com/store/apps/details?id=com.travprohybridapp.template'
        target='_blank'
      >
        <img src={google} className='google' alt='Google Play' />
      </a>
    </div>
  </div>
);

const LoginView = (props) => (
  <div className='loginView'>
    <div className='loginView__bg'>
      <div className='loginView__bg--content'>
        <img src="https://front.travpromobile.com/logos/logo_white.png" alt='Company Logo' />
        <h3>{i18n.translate('loginScreen.title')}</h3>

        <div className='buttonWrapper'>
          <MobileButtons />
        </div>
      </div>
    </div>
    <div className='loginView__content'>
      <img src={Logo} className='loginView__content--logo' alt='Logo' />
      <LoginForm
        path={props.match.path}
        keepUserStorage={props.keepUserStorage}
      />
    </div>
    <LanguageSelect
      style={{
        bottom: '2rem',
        right: '2rem',
      }}
    />
        <style>{'\
    #openWidget { display: block; bottom: 4rem; } '}
      </style>
  </div>
);

export default LoginView;

LoginView.propTypes = {
  match: PropTypes.shape({
    path: PropTypes.string.isRequired,
  }),
  keepUserStorage: PropTypes.bool,
};

LoginView.defaultProps = {
  match: {
    path: '/login',
  },
  keepUserStorage: false,
};
